import { defineComponent } from "vue";
import BrandLogo from "@/components/features/BrandLogo";
import LocaleSwitcher from "@/components/features/locale-switcher/LocaleSwitcher";
import ThemeSwitcher from "@/components/features/theme-switcher/ThemeSwitcher";
import Icon from "@/components/ui/icon/Icon";
import { $t } from "@/services/i18n";

const CONTACT_EMAIL = "support@sippulse.ai";

export default defineComponent({
  name: "MaintenancePage",
  setup() {
    const contactEmail = CONTACT_EMAIL;

    return () => (
      <div class="center relative h-screen w-full bg-background">
        <div class="center absolute right-6 top-5 gap-0.5">
          <LocaleSwitcher />
          <ThemeSwitcher />
        </div>

        <div class="center w-full max-w-md flex-col px-6">
          <div class="relative mb-10">
            <BrandLogo class="h-12" />
          </div>

          {/* Animated gears */}
          <div class="relative mb-8 flex items-center justify-center gap-1">
            <Icon
              icon="lucide:settings"
              class="h-14 w-14 animate-[spin_6s_linear_infinite] text-brand-9 opacity-80"
            />
            <Icon
              icon="lucide:settings"
              class="h-9 w-9 -ml-2.5 -mt-5 animate-[spin_4s_linear_infinite_reverse] text-brand-7 opacity-60"
            />
          </div>

          <h1 class="mb-3 text-center text-2xl font-semibold text-foreground">
            {$t("maintenance.title")}
          </h1>

          <p class="mb-8 max-w-sm text-center text-sm leading-relaxed text-muted-foreground">
            {$t("maintenance.description")}
          </p>

          {contactEmail && (
            <div class="center gap-2 rounded-lg border border-border bg-card px-5 py-3 shadow-sm">
              <Icon icon="lucide:mail" class="h-4 w-4 text-muted-foreground" />
              <span class="text-sm text-muted-foreground">
                {$t("maintenance.contact")}
              </span>
              <a
                href={`mailto:${contactEmail}`}
                class="text-sm font-medium text-brand-10 hover:underline"
              >
                {contactEmail}
              </a>
            </div>
          )}
        </div>
      </div>
    );
  },
});
